// Simple wrapper to load local esptool-js and expose it globally
// This makes the local build compatible with standalone.html code

import * as esptooljs from "./esptool-js-main/lib";

// Expose to window object for compatibility with inline scripts
(window as any).esptooljs = esptooljs;

// Log that library is loaded
console.log('✅ Local esptool-js loaded and exposed to window.esptooljs:', esptooljs);
